// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__21kV9","validationTips":"StatementDescriptor_validationTips__30Obc"};